import { Category } from '@/plugins/api'
export default {
  namespaced: true,
  state: {
    categories: [],
  },
  actions: {
    async fetchCategories({ commit }, params) {
      const res = await Category.fetch({ ...params, area: 'library' })
      commit('setCategories', res)
      return res
    },
    async findCategories({ commit }, params) {
      const res = await Category.fetch({ ...params })
      commit('setCategories', res)
      return res
    },
  },
  mutations: {
    setCategories(state, payload) {
      state.categories = payload
    },
  },
}
